module.exports = __webpack_public_path__ + "img/tujinhu.58e457f7.jpg";